import { lang } from '@umu/ukit-lang';
/*
 * @description: ai 作业效果预览
 */
import { IAiReportData } from 'businessCommon';
import { AiReportSection } from 'businessCommon/src/components';

import React, { Component } from 'react';
import './aiSummaryPreview.scss';

interface IAiSummaryProps {
    aiReportInfo: IAiReportData;
    aiVoiceCheckSwitch?: number;
    userName: string;
    expressiveMinScore: number;
    expressiveFullScore: number;
    allow_ytmw_cal_to_score?: number;
    ytmw_def_val?: number;
}
export default class AiSummaryPreview extends Component<IAiSummaryProps> {
    constructor(props: IAiSummaryProps) {
        super(props);
    }
    public render() {
        return this.renderBody();
    }
    private renderBody() {
        return (
            <div className="ai-summary">
                <div className="ai-summary-title">{lang('AI分析报告')}</div>
                {this.renderAiReport()}
            </div>
        );
    }
    private renderAiReport() {
        const {
            aiVoiceCheckSwitch,
            userName,
            aiReportInfo,
            expressiveMinScore = 0,
            expressiveFullScore = 5,
            allow_ytmw_cal_to_score,
            ytmw_def_val,
        } = this.props;
        return (
            <AiReportSection
                aiVoiceCheckSwitch={aiVoiceCheckSwitch}
                userName={userName}
                aiReportInfo={aiReportInfo}
                expressiveMinScore={expressiveMinScore}
                expressiveFullScore={expressiveFullScore}
                allow_ytmw_cal_to_score={allow_ytmw_cal_to_score}
                ytmw_def_val={ytmw_def_val}
            />
        );
    }
}
